var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isMobile
        ? [
            _c(
              "el-input",
              {
                attrs: { placeholder: _vm.item.placeholder, readonly: "" },
                nativeOn: {
                  click: function ($event) {
                    _vm.show = true
                  },
                },
                model: {
                  value: _vm.inputValue,
                  callback: function ($$v) {
                    _vm.inputValue = $$v
                  },
                  expression: "inputValue",
                },
              },
              [
                _vm.item.clearable
                  ? _c("span", { attrs: { slot: "suffix" }, slot: "suffix" }, [
                      _c("i", {
                        staticClass: "el-icon-circle-close",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.onClear.apply(null, arguments)
                          },
                        },
                      }),
                    ])
                  : _vm._e(),
              ]
            ),
            _c(
              "van-popup",
              {
                attrs: { round: "", position: "bottom" },
                model: {
                  value: _vm.show,
                  callback: function ($$v) {
                    _vm.show = $$v
                  },
                  expression: "show",
                },
              },
              [
                _c("van-cascader", {
                  attrs: {
                    "active-color": "#1890ff",
                    "field-names": _vm.fieldNames,
                    title: _vm.item.placeholder,
                    options: _vm.getOptions(),
                  },
                  on: {
                    close: function ($event) {
                      _vm.show = false
                    },
                    finish: _vm.onFinish,
                  },
                  model: {
                    value: _vm.cascaderValue,
                    callback: function ($$v) {
                      _vm.cascaderValue = $$v
                    },
                    expression: "cascaderValue",
                  },
                }),
              ],
              1
            ),
          ]
        : [
            _c(
              "el-cascader",
              _vm._b(
                {
                  attrs: {
                    "popper-class": "t-cascader-popper",
                    options: _vm.getOptions(),
                  },
                  model: {
                    value: _vm.changeValue,
                    callback: function ($$v) {
                      _vm.changeValue = $$v
                    },
                    expression: "changeValue",
                  },
                },
                "el-cascader",
                Object.assign({}, _vm.item),
                false
              )
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }